// extracted by mini-css-extract-plugin
export default {"JobFilter":"JobFilter_JobFilter__Bs7kb"};